// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2c4sc","footer":"ModalInfo_footer__129Gv"};